import React, { Component } from 'react';
import { Table, Modal, Button } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class CheckAttachment extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
    }
    
    show = record => {
        const { authorizationFileList } = record;
        this.setState({
            data: authorizationFileList,
            visible: true
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 100,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        width: 400,
        render: (text, record) => (
            <a onClick={e => this.downLoadFile(e, record.fileMateId)}>{text}</a>
        )
    }]

    getDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            })
        });

        return dataSource;
    }

    render () {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="560px"
                footer={<Button type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div>
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDateSource()}
                            rowKey={record => record.index}
                            scroll={{x: 500, y: 270}}
                            pagination={false}
                            loading={loading}
                            bordered
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default CheckAttachment



// WEBPACK FOOTER //
// ./src/components/member/crcInfo/CheckAttachment.js